import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEireAlcoholCategory implements BaseEnumType {
  private static allValues: EnumEireAlcoholCategory[] = []; // make sure this is top-most
  
  public static none = new EnumEireAlcoholCategory(0, "None", "enum_eire_alcohol_category_none");
  public static spirits = new EnumEireAlcoholCategory(1, "Spirits", "enum_eire_alcohol_category_spirits");
  public static beer = new EnumEireAlcoholCategory(2, "Beer", "enum_eire_alcohol_category_beer");
  public static wine = new EnumEireAlcoholCategory(3, "Wine", "enum_eire_alcohol_category_wine");
  public static otherFermented = new EnumEireAlcoholCategory(4, "OtherFermented", "enum_eire_alcohol_category_other_fermented");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEireAlcoholCategory.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumEireAlcoholCategory.none; }
  public isSpirits() { return this === EnumEireAlcoholCategory.spirits; }
  public isBeer() { return this === EnumEireAlcoholCategory.beer; }
  public isWine() { return this === EnumEireAlcoholCategory.wine; }
  public isOtherFermented() { return this === EnumEireAlcoholCategory.otherFermented; }

  public static getValues(): readonly EnumEireAlcoholCategory[] {
    return EnumEireAlcoholCategory.allValues;
  }

  public static getValuesExcept0(): readonly EnumEireAlcoholCategory[] {
    return EnumEireAlcoholCategory.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEireAlcoholCategory {
    const found = EnumEireAlcoholCategory.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEireAlcoholCategory - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEireAlcoholCategory): EnumEireAlcoholCategory {
    const found = name ? EnumEireAlcoholCategory.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEireAlcoholCategory - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEireAlcoholCategory>): boolean {
    return this.key === other?.key;
  }
}